module.exports = __webpack_public_path__ + "common/tp-featured3-e7cc66604f0fe4d008b930930c78ae31.svg";